class PropertyGroupFormController {
    constructor($scope, $state, propertyGroupService, messageService) {
        this.$scope = $scope;
        this.$state = $state;
        this.propertyGroupService = propertyGroupService;
        this.messageService = messageService;
    }

    onSave () {
        return this.propertyGroupService.save(this.propertyGroup)
            .then(response => {
                if (this.propertyGroup.updated_at) {
                    this.messageService.success(`The Property Group <strong>${this.propertyGroup.name}</strong> was successfully updated!`);
                } else {
                    this.messageService.success(`The Property Group <strong>${this.propertyGroup.name}</strong> was successfully created.`);
                }
                this.$state.go('app.admin.groups');
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(`The property <strong>${this.propertyGroup.name}</strong> could not be successfully created: ${error.statusText}`);
                this.messageService.push();
                var sourceElement = Object.keys(error.data)[0];
                if (sourceElement > 0) {
                    this.$scope.$ctrl.form[sourceElement].$setValidity(sourceElement, false);
                } else {
                    this.$scope.$ctrl.form.$setValidity(sourceElement, false);
                }
            });
    }
}

PropertyGroupFormController.$inject = ['$scope', '$state', 'propertyGroupService', 'messageService'];

export default PropertyGroupFormController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/controllers/property.group.form.controller.js